import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';

interface Props { 
    children: any; 
    extraStyle?: any; 
}; 

const Section: React.FC<Props> = ({ children, extraStyle }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    return (

        <Box 
            sx={[{ 
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                height: '95vh',
                width: '95vw',
                position: 'absolute',
                bottom: 0,
                right: 0, 
                overflowY: 'scroll',
                scrollbarWidth: 'none',
                paddingLeft: '6vw',
                paddingBottom: '3vh', 
                backgroundColor: colors?.interface,
                color: colors?.text, 
        }, extraStyle]}>

            {children}

        </Box>

  );

};

export default Section;